import _axios from 'axios'
import csrfToken from './csrf-token'

export default (token?: string) => {
  if (!token && document) {
    const element: HTMLMetaElement = document.head.querySelector("[name=jwt-token]");
    token = element.content;
  }

  return _axios.create({
    timeout: 5000,
    headers: {
      Authorization: `Token ${token}`,
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN' : csrfToken(),
    }
  })
}
